export default __webpack_public_path__ + "static/media/fc.b0bbb0d1.jpg";